import { emailRegex } from "react-forms-state/src";
import Translations from "translations/types";
import { z } from "zod";

export type CareproviderLoginView = "login" | "challenge";

export type GetCareproviderLoginSchemaArgs = {
  translations: Translations;
  view: CareproviderLoginView;
};

type CareproviderLoginSchema = ReturnType<typeof getCareproviderLoginSchema>;

/** Raw form state (inputs) — `challenge` stays a string in the DOM. */
export type CareproviderLoginFormValues = z.input<CareproviderLoginSchema>;

/** Post-validation shape — login view normalizes empty `challenge` to `undefined`. */
export type CareproviderLoginParsedValues = z.output<CareproviderLoginSchema>;

/** Submit payload passed to `handleLogin` — same as validated form output. */
export type CareproviderLoginSubmitPayload = CareproviderLoginParsedValues;

/** Login view: hidden challenge input submits as omitted when empty (legacy getLoginArguments). */
const loginViewChallengeField = z
  .string()
  .transform((value) => value || undefined);

export function getCareproviderLoginSchema({
  translations,
  view,
}: GetCareproviderLoginSchemaArgs) {
  if (view === "challenge") {
    return z.object({
      challenge: z
        .string()
        .min(1, translations.login.loginPage.challengeCodeValidation),
      email: z.string(),
      password: z.string(),
    });
  }

  return z.object({
    challenge: loginViewChallengeField,
    email: z
      .string()
      .regex(emailRegex, translations.login.loginPage.emailValidation),
    password: z
      .string()
      .min(1, translations.login.loginPage.passwordValidation),
  });
}
